import React, { forwardRef, LegacyRef } from 'react'

import styles from '../style.module.less'
import { BaseIconProps } from '../types'

export const Gender = forwardRef(
  (
    { _width, _height, _fill, className, spin, rtl, ...rest }: BaseIconProps,
    root: LegacyRef<SVGSVGElement>
  ) => {
    return (
      <svg
        ref={root}
        width={_width}
        height={_height}
        viewBox="0 0 48 48"
        preserveAspectRatio="xMidYMid meet"
        fill="none"
        role="presentation"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ''} ${spin ? styles.spin : ''} ${
          rtl ? styles.rtl : ''
        }`.trim()}
        {...rest}
      >
        <g>
          <defs>
            <clipPath id="bb45d__a">
              <rect
                rx="0"
                height="48"
                width="48"
              />
            </clipPath>
          </defs>
          <g
            clipPath="url(#bb45d__a)"
            style={{ mixBlendMode: 'passthrough' }}
          >
            <path
              fillRule="evenodd"
              d="M40 6h-9.027C29.868 6 29 6.91 29 8.015 29 9.09 29.913 10 31.018 10h4.153l-5.518 5.518A14.94 14.94 0 0 0 20 12c-8.284 0-15 6.716-15 15 0 8.284 6.716 15 15 15 8.284 0 15-6.716 15-15 0-3.164-.98-6.1-2.652-8.52L38 12.829v4.154c0 1.104.91 2.018 2.015 2.018A2.003 2.003 0 0 0 42 17.005v-9.01A1.995 1.995 0 0 0 40 6ZM28.183 19.648l.021.024A10.96 10.96 0 0 1 31 27c0 6.075-4.925 11-11 11S9 33.075 9 27s4.925-11 11-11a10.972 10.972 0 0 1 8.183 3.648"
              style={{ mixBlendMode: 'passthrough' }}
              data-follow-fill="#455766"
              fill={_fill}
            />
          </g>
        </g>
      </svg>
    )
  }
)
